import { z } from "zod";

import {
  basicValidator,
  dateValidator,
  reactSelectValidator,
} from "@/lib/validators";

const jobTypeSchema = z.enum([
  "DAY_CONTRACT_JOB",
  "DAY_LABOUR_JOB",
  "NIGHT_CONTRACT_JOB",
  "NIGHT_LABOUR_JOB",
]);

export const ContractJobSchema = z.object({
  customerId: basicValidator(true, "Please select a customer"),
  projectId: basicValidator(true, "Please select a project"),
  startTime: dateValidator(true),
  date: dateValidator(true),
  noe: z.coerce.number().max(9999).optional(),
  employees: reactSelectValidator(),
  notes: basicValidator(true, "Please enter notes", 0, 200),
  type: jobTypeSchema,
  isFleet: z.boolean().optional(),
  status: z.string().optional(),
  deleteEmployeeDaySheet: z.array(z.string()).optional(),
  supervisor: z.string(),
});

export type TContractJob = z.infer<typeof ContractJobSchema>;

// for updating single entitites
export const PartialContractJobSchema = ContractJobSchema.partial();
export type TPartialContractJob = z.infer<typeof PartialContractJobSchema>;

export const Employee_DaysheetSchema = z.object({
  employeeDaySheetId: basicValidator(true),
  startTime: dateValidator(true),
  isSupervisor: z.boolean().optional(),
});

export const Employee_Daysheet_ArraySchema = z.object({
  data: z.array(Employee_DaysheetSchema),
});

export type TEmployee_Daysheet = z.infer<typeof Employee_DaysheetSchema>;
export type TEmployee_Daysheet_Array = z.infer<
  typeof Employee_Daysheet_ArraySchema
>;

export const FleetSchema = z.object({
  customerId: basicValidator(true),
  projectId: basicValidator(true),
  siteAddress: basicValidator(true),
  time: dateValidator(true),
  jobDescription: basicValidator(false, "Please enter job description", 0, 200),
  report: basicValidator(false),
  date: dateValidator(true),
  isAllocated: z.boolean().optional(),
  status: z.string().optional(),
});

export type TFleet = z.infer<typeof FleetSchema>;

export const PartialFleetSchema = FleetSchema.partial();
export type TPartialFleet = z.infer<typeof PartialFleetSchema>;

export const AddAllocatedFleetSchema = z.object({
  fleetId: basicValidator(true),
  driverId: basicValidator(true),
  fleetBookingIds: z.array(z.string()),
  date: dateValidator(true),
});

export type TAddAllocatedFleet = z.infer<typeof AddAllocatedFleetSchema>;

export const UpdateAllocatedFleetSchema = AddAllocatedFleetSchema.partial();
export type TUpdateAllocatedFleet = z.infer<typeof UpdateAllocatedFleetSchema>;
